import { PartnerAlimonyQuestion } from '@hb/domain/steps/financial-obligation';
import { PartnerAlimonyStoreService } from '@hb/modules/financial-obligations/partner-alimony/partner-alimony-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { PartnerAlimonyAmountComponent } from '@hb/modules/financial-obligations/partner-alimony/partner-alimony-amount/partner-alimony-amount.component';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'partner-alimony',
    templateUrl: './partner-alimony.component.html',
    imports: [PreviousButtonComponent, PartnerAlimonyAmountComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class PartnerAlimonyComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PartnerAlimonyStoreService);
    protected activeQuestion: PartnerAlimonyQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPartnerAlimonyAmount(): boolean {
        return (
            this.activeQuestion === PartnerAlimonyQuestion.AMOUNT ||
            (this.store.isActiveQuestion(PartnerAlimonyQuestion.AMOUNT) && this.store.isSummary)
        );
    }
}
